import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/promocategoryagent`;


const ApiPromocategoryAgent = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  get: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.get(url);
  },
  addOrEditPromoCategoryAgent: (params) => {
    const url = `${baseServiceUrl}/addOrEditPromoCategoryAgent`;
    return ServiceApi.post(url, params);
  },
  updatePromoCategoryAgentStatus: (params) => {
    const url = `${baseServiceUrl}/updatePromoCategoryAgentStatus`;
    return ServiceApi.put(url, params);
  },
  removePromoCategoryAgent: (params) => {
    const url = `${baseServiceUrl}/removePromoCategoryAgent`;
    return ServiceApi.put(url, params);
  },
  addAndEditPromoCategoryCommisionAmusmentServiceCommand: (params) => {
    const url = `${baseServiceUrl}/addAndEditPromoCategoryCommisionAmusmentServiceCommand`;
    return ServiceApi.post(url, params);
  },
  update: (id, data) => {
    const url = `${baseServiceUrl}/update-amusementGroup`;
    return ServiceApi.put(url, data);
  },
  delete: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.delete(url);
  },
  getAllGroups: () => {
    const url = `${baseServiceUrl}/getAllAmusementGroups`;
    return ServiceApi.get(url);
  },
};

export default ApiPromocategoryAgent;